import React, { Component, Fragment } from 'react';
import Banner from '../../../utility_components/banner/Banner';
import {SpecialsContext} from '../../../base_components/rootComponents/Specials';
import ItemCard from '../cards/ItemCard';
import utility from "../../../functions/utility";

export default class StreamlinedSpecials extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <SpecialsContext.Consumer>
                {specialsContext => {
                    let specials = specialsContext.specialNavs.map((nav,i) => {
                        return(
                            <div className={`${utility.deviceType().includes('mobile') ? `col-12 mb-4` : `col-6 mb-2`}`} key={i}>
                                <div className={"card"} style={{minHeight: '100%'}}>
                                    <div className={"card-body d-flex flex-column"}>
                                        {
                                            nav.imageURL &&
                                                <div className={'text-center'}>
                                                    <img src={nav.imageURL} height={150} />
                                                </div>
                                        }
                                        <h3>{nav.name}</h3>
                                        <small><i>{nav.description}</i></small>
                                        <a href={`${document.location}/${nav.id}`} className={"btn btn-primary mt-auto"}>ORDER NOW</a>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                    let specialBanner = <Banner imageLarge={specialsContext.specialBannerUrl} headerText={specialsContext.specialName} />
                    return(
                        <div className={"mt-2"}>
                            <div className="text-center my-2 p-2">
                                {specialBanner}
                            </div>
                            <div className={"row"}>
                                {specials}
                            </div>
                        </div>
                    )
                }}
            </SpecialsContext.Consumer>
        )
    }
}
